<template>
    <div class="modal-share">share
        <p v-if="success" class="modal-share__message">
            Success! The link is now on your clipboard. Paste anywhere to share.
        </p>
        <p v-if="!success" class="modal-share__message">Your link is below.</p>
        <p v-if="!success" class="modal-share__message">
            Use the
            <button
                class="modal-share__message-button"
                @click="copyTextToClipboard"
            >
                <Copy></Copy> copy button
            </button>
            to add it to your clipboard.
        </p>
        <div :class="inputClassList">
            <input :value="value" type="text" />
            <button class="modal-share__button" @click="copyTextToClipboard">
                <Copy v-if="!success"></Copy>
                <Check v-else></Check>
            </button>
        </div>
    </div>
</template>
<script>
import Copy from "@/vue/icons/Copy";
import Check from "@/vue/icons/Check";
export default {
    components: {
        Copy,
        Check,
    },
    props: {
        componentProps: Object
    },
    data() {
        return {
            success: false
        }
    },
    computed: {
        inputClassList() {
            const classes = []
            classes.push('modal-share__input')
            if(this.success) {
                classes.push('modal-share__input--success')
            }
            return classes.join(' ')
        }
    },
    created() {
        Object.keys(this.componentProps).forEach((key) => {
            this[key] = this.componentProps[key];
        });
    },
    methods: {
        fallbackCopyTextToClipboard: function () {
            const textArea = document.createElement("textarea");
            textArea.value = this.value;

            // Avoid scrolling to bottom
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                const successful = document.execCommand("copy");
                successful ? this.successCopy() : this.failCopy('Failed fallback');
            } catch (err) {
                this.failCopy(err)
            }

            document.body.removeChild(textArea);
        },
        copyTextToClipboard: function () {
            if (!navigator.clipboard) {
                this.fallbackCopyTextToClipboard(this.value);
                return;
            }
            navigator.clipboard.writeText(this.value).then(
                this.successCopy,
                this.failCopy
            );
        },
        successCopy() {
            this.success = true
        },
        failCopy(err) {
            console.error("Could not copy text: ", err);
        }
    },
};
</script>
<style>
.modal-share {
    max-width: 60ch;
    font-size: var(--font-size-4);
}

.modal-share__message {
    display: flex;
    align-items: center;
    margin-bottom: 1em;
}

.modal-share__message-button {
    display: inline-flex;
    padding: 4px 8px;
    margin: 0 0.5em;
    border: 1px solid var(--color-grey-400);
    border-radius: 8px;
    cursor: pointer;
}

.modal-share__message-button:hover svg {
    color: var(--color-blue-400);
}

.modal-share__message-button svg {
    width: 1em;
    margin-top: 2px;
    margin-right: 0.5em;
}

.modal-share__input {
    display: flex;
    align-items: center;
    border: 1px solid var(--color-grey-400);
    border-radius: 8px;
    font-size: 14px;
}

.modal-share__input--success {
    border: 1px solid var(--color-green-400);
}

.modal-share__input--success input {
    color: var(--color-green-400);
}

.modal-share__input--success .modal-share__button {
    color: var(--color-green-400);
}

.modal-share__input input {
    padding: 10px 16px;
    width: 100%;
}

.modal-share__button {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 40px;
    height: 40px;
    transition: color 150ms ease-in;
}

.modal-share__button:hover {
    color: var(--color-blue-400);
}

.modal-share__button svg {
    width: 20px;
}
</style>
